import { QUERY_KEY } from 'constants/globalConstants'
import DashboardService from 'apiService/dashboardService'
import { useQuery } from 'react-query'

const useGetMttr = (order) => {
    return useQuery(QUERY_KEY.GET_MTTR, () => DashboardService.getMttr(order), {retry: false})
}

export default useGetMttr